import {
  FETCH_NOTIFICATIONS_START, FETCH_NOTIFICATIONS_SUCCESS, FETCH_NOTIFICATIONS_ERROR,
  MARK_NOTIFICATION_READ_SUCCESS, MARK_ALL_NOTIFICATIONS_READ,
  NOTIFICATION_PUSH,
  LOGOUT,
} from '../../Action/actionTypes'

const initialState = {
  notifications: [],
  items:         [],
  unreadCount:   0,
  loading:       false,
}

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_START:
      return { ...state, loading: true }
    case FETCH_NOTIFICATIONS_SUCCESS: {
      const list = action.payload.notifications ?? []
      return {
        ...state,
        loading:       false,
        notifications: list,
        items:         list,
        unreadCount:   action.payload.unread_count ?? 0,
      }
    }
    case FETCH_NOTIFICATIONS_ERROR:
      return { ...state, loading: false }

    case MARK_NOTIFICATION_READ_SUCCESS: {
      const updated = state.notifications.map((n) =>
        n.id === action.payload ? { ...n, read: true } : n
      )
      return {
        ...state,
        notifications: updated,
        items:         updated,
        unreadCount:   Math.max(0, state.unreadCount - 1),
      }
    }

    case MARK_ALL_NOTIFICATIONS_READ: {
      const readAll = state.notifications.map((n) => ({ ...n, read: true }))
      return {
        ...state,
        notifications: readAll,
        items:         readAll,
        unreadCount:   0,
      }
    }

    case NOTIFICATION_PUSH: {
      const incoming = action.payload
      // Deduplicate — ignore if we already have this notification (e.g. from polling)
      if (state.notifications.some((n) => n.id === incoming.id)) return state
      const newList = [incoming, ...state.notifications]
      return {
        ...state,
        notifications: newList,
        items:         newList,
        unreadCount:   state.unreadCount + 1,
      }
    }

    case LOGOUT:
      return initialState

    default:
      return state
  }
}

export default notificationsReducer
